import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/ctJointly/banner.png'
import navColor from '../../assets/ctJointly/nav/color.png'
import navBg from '../../assets/ctJointly/nav/nav_bg.png'
import navBgFixed from '../../assets/ctJointly/nav/nav_bg_fixed.png'

import far1 from '../../assets/ctJointly/nav/far1.png'
import far1_active from '../../assets/ctJointly/nav/far1_active.png'
import far2 from '../../assets/ctJointly/nav/far2.png'
import far2_active from '../../assets/ctJointly/nav/far2_active.png'
import far3 from '../../assets/ctJointly/nav/far3.png'
import far3_active from '../../assets/ctJointly/nav/far3_active.png'
import son1 from '../../assets/ctJointly/nav/son1.png'
import son1_active from '../../assets/ctJointly/nav/son1_active.png'
import son2 from '../../assets/ctJointly/nav/son2.png'
import son2_active from '../../assets/ctJointly/nav/son2_active.png'
import son3 from '../../assets/ctJointly/nav/son3.png'
import son3_active from '../../assets/ctJointly/nav/son3_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(146.5),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(146.5),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(146.5),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    padding: `0 ${calcRemFn(55)}`,
    paddingTop: `${calcRemFn(33)}`
  },
  topBtnBaseCss: {
    width: calcRemFn(76),
    height: calcRemFn(37.5)
  },
  bottomBtnLayout: {
    marginTop: `${calcRemFn(5)}`,
    padding: `${calcRemFn(0)} ${calcRemFn(55)}`,
    alignItems: 'center'
  },
  bottomBtnBaseCss: {
    width: calcRemFn(76),
    height: calcRemFn(31),
    marginTop: calcRemFn(0),
    marginLeft: calcRemFn(0),
  }
}

const navData = {
  // weddingDressCooperation20220409Spec: true,
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      }
    ]
  }
}
const pictureList = [
  {
    key: '1_1',
    picNum: 3,
    pid: 106234
  },
  {
    key: '1_2',
    picNum: 3,
    pid: 106234
  },
  {
    key: '1_3',
    picNum: 2,
    pid: 106234
  },
  {
    key: '2_1',
    picNum: 2,
    pid: 106236
  },
  {
    key: '2_2',
    picNum: 2,
    pid: 106236
  },
  {
    key: '2_3',
    picNum: 3,
    pid: 106236
  },
  {
    key: '3_1',
    picNum: 1,
    pid: 106235
  },
  {
    key: '3_2',
    picNum: 2,
    pid: 106235
  },
  {
    key: '3_3',
    picNum: 2,
    pid: 106235
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/ctJointly/ctn/${key}_${index + startIndex + 1}.png`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'gold',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

pictures.push({
  son: [
    require('../../assets/ctJointly/ctn/4_1_3.png')
  ],
  fun: 'toNewWedding'
})

function toNewWedding () {
  // window.location.href = window.location.origin + window.location.pathname + `?t=${new Date().getTime()}#/theme/weddingDress20220409`
  // this.$router.push({ path: '/theme/newWedding' })
}

function onlonadFun (_this) {
  _this.toNewWedding = toNewWedding
}

const topDiff = {
  firstSon: '_i1',
  // top1_i1: 10,
  // top1_i2: 20,
  // top2_i1: 5,
  // top2_i2: 16,
}

export default {
  title: 'Charlotte Tilbury 联名款',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
  onlonadFun
}
